import React from 'react';

/**
 * Fängt Render-Fehler ab und zeigt eine Meldung statt weißen Bildschirm.
 */
export class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('App-Fehler:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            background: '#f1f5f9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            fontFamily: 'system-ui, sans-serif',
            color: '#1e293b',
          }}
        >
          <div style={{ maxWidth: 480, background: '#fff', padding: 24, borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <h1 style={{ margin: '0 0 12px', fontSize: '1.25rem', color: '#dc2626' }}>Fehler beim Laden der App</h1>
            <p style={{ margin: '0 0 16px', color: '#475569', fontSize: '0.9375rem' }}>
              {this.state.error?.message || 'Ein unerwarteter Fehler ist aufgetreten.'}
            </p>
            <p style={{ margin: 0, fontSize: '0.875rem', color: '#64748b' }}>
              Öffne die Browser-Konsole (F12 → Konsole), um Details zu sehen.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
